export class RebateSettlementFrequencyDto {
  id: number;
  name: string;
}